var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHardwareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    transform: "translate(-0.025)",
    fill: "#d7e0ff",
    stroke: "#0182f0",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 23.5,
    height: 23.5,
    rx: 3.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    transform: "translate(3.125 13.542)",
    fill: "#d7e0ff",
    stroke: "#0182f0",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 6.25,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 17.25,
    height: 4.75,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(15 5.182)",
    fill: "#d7e0ff",
    stroke: "#0182f0",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3,
    rx: 2.75,
    ry: 2.25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHardwareIcon);
export default __webpack_public_path__ + "static/media/order-hardware-icon.623d6c315f58d4a6c613c0915bca2e5e.svg";
export { ForwardRef as ReactComponent };